// extracted by mini-css-extract-plugin
module.exports = {"mirror":"Mirror_mirror__1KJPt","cover":"Mirror_cover__3CxCA","error":"Mirror_error__2930P"};